import {
  convertApiResultToBets,
  extractBetSettings,
} from "@/utils/betslip-transform";

export { extractBetSettings };

const stateBetslip = {
  state: {
    betslips: {},
    showAddedNotify: false,
    isBetslipApiLoading: false,
  },
  mutations: {
    saveBetslips(state: any, payload: { key: string; value: any }) {
      state.betslips[payload.key] = payload.value;
    },
    setShowAddedNotify(state: any, value: boolean) {
      state.showAddedNotify = value;
    },
    setBetslipApiLoading(state: any, value: boolean) {
      state.isBetslipApiLoading = value;
    },
  },
  actions: {
    appendFromApiResult(
      { state, rootState, commit }: any,
      {
        apiResult,
        isCombination = false,
        outcome = null,
      }: { apiResult: any[]; isCombination?: boolean; outcome?: Record<string, any> | null }
    ) {
      const accountKey = rootState.accountKey;
      if (!accountKey || !apiResult?.length) return;

      const betSettings = outcome
        ? extractBetSettings(outcome)
        : extractBetSettings();

      const newBets = convertApiResultToBets(
        apiResult,
        rootState.gameMarket,
        betSettings,
        {
          isCombination,
          defaultWager: outcome?.amount ?? outcome?.bet_default,
        }
      );

      const current = state.betslips[accountKey] ?? [];
      commit("saveBetslips", {
        key: accountKey,
        value: [...current, ...newBets],
      });
      commit("setShowAddedNotify", true);
    },
  },
};

export default stateBetslip;
